<template>
  <div v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="flex">
          <div class="w-full">
            <vs-button
              @click="showFilters = !showFilters"
              class="bg_purple float-right"
              ><div class="px-3">
                <feather-icon
                  icon="FilterIcon"
                  svgClasses="h-4 w-4"
                  class="ico"
                />
                {{ $t("Filter") }}
              </div>
            </vs-button>
          </div>
        </div>
        <div
          class="vx-row px-2 flex gap-y-4 items-end pt-4 flex-warp"
          v-if="showFilters"
        >
          <div class="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 px-2">
            <label class="vs-select--label my-1">{{
              $t("BalanceStatus")
            }}</label>
            <v-select
              label="name"
              :options="stockBalanceOptions"
              v-model="gridSearchData.stockBalanceFilter"
              :reduce="(x) => x.id"
              :clearable="false"
              ref="agentType"
              dir="rtl"
            >
            </v-select>
          </div>
          <div class="flex gap-4 px-2 flex-grow justify-end">
            <vs-button
              type="filled"
              class="float-right"
              color="#3ec9d6"
              @click.prevent="resetForm"
              >{{ $t("ResetFilter") }}</vs-button
            >
            <vs-button
              type="filled"
              class="float-right"
              @click.prevent="submitFilter"
              >{{ $t("SubmitFilter") }}</vs-button
            >
          </div>
        </div>
        <div class="vx-row pt-4">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('ProductName'), sort: 'ProductName' },
                { title: $t('ItemCode'), sort: 'ItemCode' },
                { title: $t('PhysicalBalance'), sort: 'PhysicalBalance' },
                { title: $t('Action') },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 50%" :title="row.stockName">
                  {{ row.stockName | truncate(120) }}
                </td>
                <td style="width: 12%">
                  {{ row.itemCode }}
                </td>
                <td style="width: 12%">
                  {{ row.physicalBalance }}
                </td>
                <td style="width: 24%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="view-btn"
                    @click.prevent="viewSerials(row.stockId)"
                    >{{ $t("ViewSerials") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
          </div>
        </div>
        <serial-popup
          :show="SerialPopup"
          @close="closeSerialPopup"
          :popupService="popupService"
        ></serial-popup>
      </div>
    </div>
  </div>
</template>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "@/components/CustomVSelect.vue";
import SerialPopup from "./SerialPopup.vue";
export default {
  name: "warehouseManagement_Reports_SerialBalance_Index",
  components: {
    DataGrid,
    SerialPopup,
    vSelect,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Inventory/api/SerialsOfStockQuery",
      },
      gridSearchData: {
        keyword: "",
        stockBalanceFilter: 1,
      },
      SerialPopup: false,
      popupService: "",
      showFilters: false,
      stockBalanceOptions: [
        { name: "همه", id: 0 },
        { name: "موجود", id: 1 },
        { name: "ناموجود", id: 2 },
      ],
    };
  },
  methods: {
    viewSerials(id) {
      this.popupService = "/Inventory/api/SerialsOfStockQuery/" + id;
      this.SerialPopup = true;
    },
    closeSerialPopup() {
      this.SerialPopup = false;
    },
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {};
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
  },
};
</script>
